module.exports = __webpack_public_path__ + "static/media/about3.29c543d8.jpg";